<template>
  <div class="block-div">
    <div class="error"><h4>{{ errorMessage }}</h4></div>
  </div>
</template>

<script>
export default {
  name: "ErrorPage",
  props: [
    'errorMessage'
  ],
}
</script>

<style scoped>
.block-div {
  text-align: center;
}
</style>
